export default {
    'now_serving': 'Now serving',
    'next': 'Next',
    'token': 'Token',
    'room': 'Room {room}',
    'counter': 'Counter {counter}',
    'please_wait': 'Please wait to be called',
    'doctor': 'Doctor',
    'waiting': '{count, plural, one {# waiting} other {# waiting}}',
    'no_clinics': 'No clinics are running at the moment.',
    'loading': 'Loading…',
};
//# sourceMappingURL=queue.js.map